import React from 'react';
import { Play, Headphones } from 'lucide-react';
import { useParallax } from '../hooks/useParallax';
export function Hero() {
  const {
    ref: bgRef,
    style: bgStyle
  } = useParallax(0.3);
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-90">
      {/* Background */}
      <div className="absolute inset-0 z-0 bg-eofa-black" data-id="element-91" />

      {/* Content */}
      <div className="container relative z-20 mx-auto px-6 flex flex-col items-center text-center mt-10" data-id="element-92">
        <span className="text-eofa-white tracking-[0.2em] text-[13px] uppercase font-bold mb-6" data-id="element-93">
          THE EOFA PODCAST
        </span>

        <h1 className="text-eofa-white font-heading font-black text-[40px] leading-[1.1] md:text-[80px] lg:text-[100px] mb-6 tracking-tighter max-w-[1000px]" data-id="element-94">
          <span className="font-script text-eofa-yellow font-normal text-[50px] md:text-[100px] lg:text-[130px] inline-block -rotate-2 mr-2 md:mr-4" data-id="element-95">
            Entrepreneurs
          </span>
          <br className="md:hidden" data-id="element-96" />
          of America
        </h1>

        <p className="text-eofa-body text-lg md:text-xl font-medium max-w-[700px] mb-10 leading-relaxed" data-id="element-97">
          Real conversations with the everyday business owners building Arizona.
          Unfiltered stories, hard lessons, and the playbooks behind real
          success.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto mb-12" data-id="element-98">
          <a href="https://www.youtube.com/@EofApod" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-eofa-yellow text-eofa-black font-bold rounded-md px-8 min-h-[48px] hover:bg-yellow-400 transition-colors" data-id="element-99">
            <Play size={20} className="fill-current" data-id="element-100" />
            Watch on YouTube
          </a>
          <a href="https://open.spotify.com/show/4IHMpSES2R4Zx4t0Et2oX8" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-transparent border-2 border-eofa-white text-eofa-white font-bold rounded-md px-8 min-h-[48px] hover:bg-eofa-white hover:text-eofa-black transition-colors" data-id="element-101">
            <Headphones size={20} data-id="element-102" />
            Listen on Spotify
          </a>
        </div>

        {/* Platform Icons */}
        <div className="flex items-center gap-6 text-eofa-muted" data-id="element-103">
          <a href="https://www.youtube.com/@EofApod" target="_blank" rel="noopener noreferrer" className="hover:text-eofa-yellow transition-colors" aria-label="YouTube" data-id="element-104">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-105">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-106" />
            </svg>
          </a>
          <a href="https://open.spotify.com/show/4IHMpSES2R4Zx4t0Et2oX8" target="_blank" rel="noopener noreferrer" className="hover:text-eofa-yellow transition-colors" aria-label="Spotify" data-id="element-107">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-108">
              <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.48.659.24 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.84.24 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.6.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.54-1.02.72-1.56.3z" data-id="element-109" />
            </svg>
          </a>
        </div>
      </div>
    </section>;
}